// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { css, keyframes } from 'styled-components';

import { Target } from '../../client';
import { MyMatchLongErrorLabels } from '../../constants/mymatch';
import { ZIndices } from '../../styled-components/dark/common';
import { type MyMatchAPIErrorId } from '../../types/mymatch';
import AdaptativeModal from '../AdaptativeModal';
import InfosLabel, { InfosLabelTypes } from '../InfosLabel/InfosLabel';

const StyledAdaptativeModal = styled(AdaptativeModal)`
  ${Target.__MOBILE__
    ? css`
        left: 1em;
        top: calc(100% - var(--tabbar-height) - 0.5em);
        transform: translateY(-100%);
      `
    : css`
        font-size: 120%;
        top: calc(100% - var(--tabbar-height) - 0.5em);
        transform: translate(-50%, -100%);
      `}
`;

const glowingAnim = keyframes`
  50% {
    opacity: 0.025;
  }
`;

const StyledInfosLabel = styled(InfosLabel)`
  padding: 0.75em 1em;

  ${Target.__MOBILE__
    ? css`
        padding-right: 5em;
      `
    : undefined}

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    border-radius: inherit;
    background-color: #ffffffff;
    opacity: 0;

    animation: ${glowingAnim} 2000ms ease-in-out infinite;
  }
`;

type MyMatchErrorPopUpProps = {
  matchMMErrorId: MyMatchAPIErrorId;
  show: boolean;
};

const MyMatchErrorPopUp = ({ show, matchMMErrorId }: MyMatchErrorPopUpProps) => {
  const errorLabel = useMemo(() => MyMatchLongErrorLabels[matchMMErrorId](), [matchMMErrorId]);

  return (
    <StyledAdaptativeModal
      identifier="my-match-error-popup"
      show={show}
      hideCloseButton
      hideOverlay
      zIndex={ZIndices.floatingMyMatchErrorPopUp}
    >
      <StyledInfosLabel label={errorLabel} symbol={'!'} type={InfosLabelTypes.INFOS_RED} />
    </StyledAdaptativeModal>
  );
};

export default MyMatchErrorPopUp;
